import * as api from '../api/adapters/json_api';


const type = 'api_resources/ac_budget_items';

export default {
  index: (pagination, sort, id) => api.read({ type, id }, {
    query: { sort: 'item'}
  }),
  roots: () => api.read({type}, {
    query: {filter: {roots: true}, sort: 'item'}
  }),
  balance: (id, params) => api.read({type, id, action: 'balance'}, { query: params }),

  // FIN-1245: the Budget Performance block of the Dashboard's Fleet section
  dashboardFleet: ({ vesselIds, year } = {}) => api
    .read({ type, id: 'dashboard_fleet' }, { query: { vessel_ids: vesselIds, year } })
    .then((response) => response.data.data),
}
